/**
 * card-picker.js
 *
 * This code is maintained and developped by Deployer.
 * Any changes in this file will be overridden by Deployer.
 * If you want to customize this file,
 * we recommend to create a new one and dispatch custom events from it to make any changes.
 *
 *  */

class ProductCardPicker extends HTMLElement {
  constructor() {
    super();
    (this.quantityPicker = this.querySelector('td-quantity-picker')),
      (this.buttonAddToCart = this.querySelector('.td-quantity-picker--atc-button')),
      (this.arrayOfVariants = []);
  }

  connectedCallback() {
    this.listenEvents();
    this.loadArrayOfVariants(this.arrayOfVariants);
  }

  listenEvents() {
    //you must dispatch an event on the theme logic when the variant changes
    document.addEventListener('deployer:variant-changed', (event) => {
      this.updateVariant(event.detail.variant_id);
    });

    //deployer custom event
    document.addEventListener('deployer:quantity-changed', (event) => {
      this.updateQuantity(event.detail.quantity);
    });
    this.buttonAddToCart.addEventListener('click', this.addToCart.bind(this));
  }

  loadArrayOfVariants(array) {
    this.querySelectorAll(`[data-image-1]`).forEach((variant, index) => {
      for (let i = 1; i < 4; i++) {
        array.push({
          id: parseInt(variant.dataset.id),
          image: variant.dataset[`image-${i}`],
        });
      }
    });
  }

  isVariantAvailable(variant) {
    variant.available ? (this.buttonAddToCart.disabled = false) : (this.buttonAddToCart.disabled = true);
  }

  updateQuantity(quantity) {
    this.buttonAddToCart.dataset.quantity = quantity;
  }

  updateVariant(variantId) {
    this.buttonAddToCart.dataset.id = variantId;
    this.updateCards(variantId);
  }

  updateCards(variantId) {
    this.updateImageInCards(variantId);
  }

  updateImageInCards(currentVariantId) {
    this.arrayOfFilteredVariants = this.arrayOfVariants.filter((variant) => parseInt(variant.id) === parseInt(currentVariantId));

    this.arrayOfFilteredVariants.forEach((variant, array_index) => {
      this.querySelectorAll('.pack__unit').forEach((card, card_index) => {
        if (card_index === array_index) {
          if (parseInt(variant.id) === parseInt(currentVariantId)) {
            this.updateImageInEachCard(card, variant.image);
          }
        }
      });
    });
  }

  updateImageInEachCard(card, image) {
    card.querySelector('.pack__image').src = image;
  }

  onCardSelection(button) {
    const quantity = button.dataset.quantity;
    this.updateQuantity(quantity);

    this.querySelectorAll('.pack__unit').forEach((pack, index) => {
      this.onCardDeselection(pack);
    });
    button.setAttribute('data-selected', 'true');
  }

  onCardDeselection(button) {
    button.removeAttribute('data-selected');
  }

  addToCart() {
    // fetch data and function from theme logic
    const fetchedData = {
      id: parseInt(document.querySelector('#mmVariantId').value),
      quantity: parseInt(this.buttonAddToCart.dataset.quantity),
    };

    mmAddProductToCart(fetchedData.id, { quantity: fetchedData?.quantity, openCart: true });
  }
}

window.customElements.define('product-card-picker', ProductCardPicker);

class ProductQuantityPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.selectClickedCard();
  }

  selectClickedCard() {
    this.querySelectorAll('.pack__unit').forEach((card, generalIndex) => {
      card.addEventListener('click', (element) => {
        this.querySelectorAll('.pack__unit').forEach((card, childrenIndex) => {
          generalIndex === childrenIndex ? this.selectCurrentCard(card) : this.deselectCard(card);
        });
      });
    });
  }

  selectCurrentCard(card) {
    card.setAttribute('data-selected', 'true');

    document.dispatchEvent(
      new CustomEvent('deployer:quantity-changed', {
        detail: {
          quantity: card.dataset.quantity,
        },
      }),
    );
  }

  deselectCard(card) {
    card.removeAttribute('data-selected');
  }
}

window.customElements.define('product-quantity-picker', ProductQuantityPicker);
